var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewportSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "viewportSix",
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.929,
    height: 111,
    viewBox: "0 0 135.929 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    transform: "translate(74.417 60.563)",
    fill: "none",
    stroke: "#427a98",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.512,
    height: 50.438,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 53.512,
    height: 42.438,
    rx: 14,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1888",
    "data-name": "Path 1888",
    transform: "translate(74.417)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0H43.512a18,18,0,0,1,18,18V33.341a18,18,0,0,1-18,18H18a18,18,0,0,1-18-18V18A18,18,0,0,1,18,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.00000381469727 8.000003814697266 C 12.48598861694336 8.000003814697266 8.000003814697266 12.48598861694336 8.000003814697266 18.00000381469727 L 8.000003814697266 33.34130477905273 C 8.000003814697266 38.85531997680664 12.48598861694336 43.34130477905273 18.00000381469727 43.34130477905273 L 43.51220321655273 43.34130477905273 C 49.02622222900391 43.34130477905273 53.51220321655273 38.85531997680664 53.51220321655273 33.34130477905273 L 53.51220321655273 18.00000381469727 C 53.51220321655273 12.48598861694336 49.02622222900391 8.000003814697266 43.51220321655273 8.000003814697266 L 18.00000381469727 8.000003814697266 M 18.00000381469727 3.814697265625e-06 L 43.51220321655273 3.814697265625e-06 C 53.45333862304688 3.814697265625e-06 61.51220321655273 8.058872222900391 61.51220321655273 18.00000381469727 L 61.51220321655273 33.34130477905273 C 61.51220321655273 43.28243637084961 53.45333862304688 51.34130477905273 43.51220321655273 51.34130477905273 L 18.00000381469727 51.34130477905273 C 8.058868408203125 51.34130477905273 3.814697265625e-06 43.28243637084961 3.814697265625e-06 33.34130477905273 L 3.814697265625e-06 18.00000381469727 C 3.814697265625e-06 8.058872222900391 8.058868408203125 3.814697265625e-06 18.00000381469727 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#e388ad"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    transform: "translate(0 60.563)",
    fill: "none",
    stroke: "#b5d36d",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.091,
    height: 50.438,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 55.091,
    height: 42.438,
    rx: 14,
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    fill: "none",
    stroke: "#f6c543",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.091,
    height: 51.341,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 55.091,
    height: 43.341,
    rx: 14,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewportSix);
export default __webpack_public_path__ + "static/media/viewportSix.6b13b86dfe13153420566ac142d095ce.svg";
export { ForwardRef as ReactComponent };